import fetch from 'utils/fetch';

export function changeIpRateList(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/changeIpRateList',
        method: 'post',
        data
    });
}

export function addChangeIpRate(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/addChangeIpRate',
        method: 'post',
        data
    });
}

export function editChangeIpRate(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/editChangeIpRate',
        method: 'post',
        data
    });
}

export function deleteChangeIpRate(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/deleteChangeIpRate',
        method: 'post',
        data
    });
}


// WEBPACK FOOTER //
// ./src/api/changeIpRate.js